import { Injectable } from "@angular/core";
import { SettingDTO } from "../models/settings.model";
import { CacheNamesEnum } from "../models/shared.model";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public getSettingValue(key: string): any {

    const settings = JSON.parse(window.localStorage.getItem(CacheNamesEnum.SETTINGS)!) as SettingDTO[];

    if(settings == null || settings.length == 0)
      return null;

    const setting = settings.find(s => s.key === key);
    const value = setting?.value ?? setting?.default;

    if(value === '1')
      return true;
    if(value === '0')
      return false;

    return value;
  }

  constructor() { }
}
